import Tip from './Tip';
export default Tip;



/** WEBPACK FOOTER **
 ** ./src/components/Tip/index.ts
 **/